/** Extract user-facing assistant text from an ACP `session/update` payload. */
export function extractSessionUpdateMessageText(params: unknown): string | null {
  if (params == null || typeof params !== 'object' || Array.isArray(params)) return null;
  const o = params as Record<string, unknown>;

  if (typeof o.text === 'string' && o.text.length > 0) return o.text;

  const content = o.content;
  if (typeof content === 'string' && content.length > 0) return content;
  if (content != null && typeof content === 'object' && !Array.isArray(content)) {
    const c = content as Record<string, unknown>;
    if (typeof c.text === 'string' && c.text.length > 0) return c.text;
  }

  const update = o.update;
  if (typeof update === 'string' && update.length > 0) return update;
  if (update != null && typeof update === 'object' && !Array.isArray(update)) {
    const u = update as Record<string, unknown>;
    const innerContent = u.content;
    if (typeof innerContent === 'string' && innerContent.length > 0) return innerContent;
    if (innerContent != null && typeof innerContent === 'object' && !Array.isArray(innerContent)) {
      const ic = innerContent as Record<string, unknown>;
      if (typeof ic.text === 'string' && ic.text.length > 0) return ic.text;
    }
  }

  return null;
}
